import * as RadixSwitch from "@radix-ui/react-switch";

export const Root = RadixSwitch.Root;
export const Thumb = RadixSwitch.Thumb;
